module.exports = __webpack_public_path__ + "static/media/back1.6c73d6b2.jpg";